const printHtml = {
  methods: {
    printHtml(title, html, image) {
      try {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(html);
        doc.close();

        const saveTitle = document.title;
        document.title = title;

        if (image) {
          const images = image instanceof Array ? image : [image];
          let imageCount = images.length;
          for (const i of images) {
            const imageElement = doc.getElementById(i.id);
            if (imageElement) {
              imageElement.onload = () => {
                if (--imageCount === 0) {
                  setTimeout(() => {
                    iframe.contentWindow.print();
                    document.body.removeChild(iframe);
                  }, 500);
                }
              }
              imageElement.src = i.src;
            }
          }
        }

        else {
          setTimeout(() => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
          }, 500);
        }

        document.title = saveTitle;
      } catch (error) {
        console.log(error);
        this.$apiCall(`mutation printHtml($input:ClientErrorInput!) {
          logClientError(input:$input)
        }`,{input:{query:'DEBUG ERROR', variables:'',
                    error:JSON.stringify(error.stack)}});

      }
    }
  }
}

export default printHtml;